
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { PatentLegalStatusService } from '../patent-legal-status-service';
import { PatentLegalStatusApi } from '@telecom/shared/infrastructure/api-functions/patent-legal-status-api';

@injectable()
export class PatentLegalStatusServiceImpl implements PatentLegalStatusService {
    constructor(
        @inject(PatentLegalStatusApi)
        private readonly _patentLegalStatusApi: PatentLegalStatusApi,
    ) {}
    getPatentLegalStatus(): Promise<any> {
        return this._patentLegalStatusApi.getPatentLegalStatus();
    }
}
